import { render, staticRenderFns } from "./ProjectDocumentsSideBar.vue?vue&type=template&id=5432642c"
import script from "./ProjectDocumentsSideBar.vue?vue&type=script&lang=ts"
export * from "./ProjectDocumentsSideBar.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5432642c')) {
      api.createRecord('5432642c', component.options)
    } else {
      api.reload('5432642c', component.options)
    }
    module.hot.accept("./ProjectDocumentsSideBar.vue?vue&type=template&id=5432642c", function () {
      api.rerender('5432642c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/contractors/ProjectDocumentsSideBar.vue"
export default component.exports